const ENDPOINT = process.env.REACT_APP_ENDPOINT

const addUserContentRec = async (title, type) => {
    try {
        const response = await fetch(`${ENDPOINT}/missing_data`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ title, type })
        })
        const resp = await response.json();
        return resp;
    }
    catch (error) {
        console.error('Error checking match:', error);
    }
}

export default addUserContentRec;